<div class="pagetitle">
  <h2>Tags{{ project?.name ? ': ' + project.name : '' }}</h2>
</div>
<alert></alert>

<form class="form-inline mb-2" [formGroup]="tagForm" (ngSubmit)="saveTag()" novalidate>
  <input type="text" class="form-control form-control-sm mr-2" formControlName="name" placeholder="Tag name" aria-label="Tag name">
  <input type="color" class="mr-2" formControlName="color" aria-label="Tag colour">
  <button type="submit" class="btn btn-sm btn-outline-success mr-2" [disabled]="tagForm.invalid || submitted">{{ editing ? 'Save tag' : 'Create tag' }}</button>
  @if (editing) {
    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="resetForm()">Cancel</button>
  }
</form>
@for (error of formErrors; track error) {
  <div class="text-danger small">{{ error }}</div>
}

<div class="table-responsive mt-2">
  <table class="table table-bordered table-striped table-sm table-hover" width="100%" cellspacing="0">
    <thead>
      <tr>
        <th class="sort-na">Name</th>
        <th class="sort-na">Colour</th>
        <th class="text-right sort-na">Files</th>
        <th width="250" class="sort-na">Action</th>
      </tr>
    </thead>
    <tbody>
      @if (loading || msg) {
        <tr><td colspan="4" class="loading text-center">{{ loading ? 'Loading...' : msg }}</td></tr>
      }
      @for (tag of tags; track tag.id) {
        <tr>
          <td><span class="badge" [style.background-color]="tag.color" [style.color]="tagTextColor(tag.color)">{{ tag.name }}</span></td>
          <td>{{ tag.color }}</td>
          <td class="text-right">{{ tag.fileCount | number }}</td>
          <td class="text-center">
            <a class="btn btn-primary btn-xs" [routerLink]="['/dashboard/project', projectId, 'tags', tag.id]" [state]="{ data: { project: project } }" [style.color]="'white'" title="View Tag"><i class="fas fa-eye"></i> View</a>&nbsp;
            <a class="btn btn-edit btn-xs" href="javascript:;" (click)="editTag(tag)" title="Edit Tag"><i class="fa fa-fw fa-edit"></i> Edit</a>&nbsp;
            <a class="btn btn-delete btn-xs" href="javascript:;" (click)="deleteTag(tag)" title="Delete Tag"><i class="fa fa-fw fa-trash"></i> Delete</a>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
<a [routerLink]="['/dashboard/project/list']" class="btn btn-sm btn-primary">Back to Project List</a>
